var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	57910: {
		fallback: function() { return Promise.all([__webpack_require__.e(408), __webpack_require__.e(664), __webpack_require__.e(8766)]).then(function() { return function() { return __webpack_require__(40664); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	39818: {
		fallback: function() { return __webpack_require__.e(912).then(function() { return function() { return __webpack_require__(70912); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	56549: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(13274); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	23623: {
		fallback: function() { return __webpack_require__.e(5283).then(function() { return function() { return __webpack_require__(65283); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	62019: {
		fallback: function() { return Promise.all([__webpack_require__.e(408), __webpack_require__.e(3821)]).then(function() { return function() { return __webpack_require__(33821); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	36243: {
		fallback: function() { return Promise.all([__webpack_require__.e(8766), __webpack_require__.e(7261)]).then(function() { return function() { return __webpack_require__(9642); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	17253: {
		fallback: function() { return __webpack_require__.e(6292).then(function() { return function() { return __webpack_require__(16292); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	44637: {
		fallback: function() { return __webpack_require__.e(6172).then(function() { return function() { return __webpack_require__(76172); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	668: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(79474); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	71383: {
		fallback: function() { return __webpack_require__.e(1197).then(function() { return function() { return __webpack_require__(31197); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	68153: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(48088); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	28766: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(41615); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	66025: {
		fallback: function() { return __webpack_require__.e(8495).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.11.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	97478: {
		fallback: function() { return __webpack_require__.e(8495).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.9.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	6140: {
		fallback: function() { return __webpack_require__.e(2698).then(function() { return function() { return __webpack_require__(52698); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.0.22",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	95791: {
		fallback: function() { return Promise.all([__webpack_require__.e(8933), __webpack_require__.e(8268), __webpack_require__.e(1778)]).then(function() { return function() { return __webpack_require__(38268); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.0.22",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	6062: {
		fallback: function() { return Promise.all([__webpack_require__.e(8933), __webpack_require__.e(8268), __webpack_require__.e(6140), __webpack_require__.e(1778)]).then(function() { return function() { return __webpack_require__(38268); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	52041: {
		fallback: function() { return __webpack_require__.e(2698).then(function() { return function() { return __webpack_require__(52698); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	11778: {
		fallback: function() { return __webpack_require__.e(6114).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=11.9.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	43526: {
		fallback: function() { return __webpack_require__.e(8495).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.11.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	39609: {
		fallback: function() { return Promise.all([__webpack_require__.e(9905), __webpack_require__.e(8070), __webpack_require__.e(6025), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791), __webpack_require__.e(2714)]).then(function() { return function() { return __webpack_require__(58070); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=3.13.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	25609: {
		fallback: function() { return __webpack_require__.e(8495).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.13.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	15119: {
		fallback: function() { return __webpack_require__.e(1657).then(function() { return function() { return __webpack_require__(11657); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">= 13.5.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",
	},
	76643: {
		fallback: function() { return __webpack_require__.e(4200).then(function() { return function() { return __webpack_require__(94200); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">= 23.7.13",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",
	},
	68941: {
		fallback: function() { return __webpack_require__.e(2698).then(function() { return function() { return __webpack_require__(52698); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~6.0.22",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	13299: {
		fallback: function() { return Promise.all([__webpack_require__.e(9905), __webpack_require__.e(8070), __webpack_require__.e(6025), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791), __webpack_require__.e(2714)]).then(function() { return function() { return __webpack_require__(58070); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.14.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	25794: {
		fallback: function() { return __webpack_require__.e(1657).then(function() { return function() { return __webpack_require__(11657); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",
	},
	56497: {
		fallback: function() { return __webpack_require__.e(4459).then(function() { return function() { return __webpack_require__(94459); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.45.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@hackler/react-sdk",
	},
	13832: {
		fallback: function() { return __webpack_require__.e(4200).then(function() { return function() { return __webpack_require__(94200); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^23.14.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",
	},
	15173: {
		fallback: function() { return __webpack_require__.e(6172).then(function() { return function() { return __webpack_require__(76172); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "13.4.9",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	79974: {
		fallback: function() { return Promise.all([__webpack_require__.e(9905), __webpack_require__.e(8070), __webpack_require__.e(6025), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791), __webpack_require__.e(2714)]).then(function() { return function() { return __webpack_require__(58070); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.4.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	72121: {
		fallback: function() { return __webpack_require__.e(5283).then(function() { return function() { return __webpack_require__(65283); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "13.4.9",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	99046: {
		fallback: function() { return Promise.all([__webpack_require__.e(8933), __webpack_require__.e(8268), __webpack_require__.e(6140), __webpack_require__.e(1778)]).then(function() { return function() { return __webpack_require__(38268); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~6.0.22",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	1509: {
		fallback: function() { return __webpack_require__.e(4200).then(function() { return function() { return __webpack_require__(94200); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^23.15.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",
	},
	37662: {
		fallback: function() { return Promise.all([__webpack_require__.e(9905), __webpack_require__.e(8070), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791)]).then(function() { return function() { return __webpack_require__(58070); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.7.10",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	62105: {
		fallback: function() { return __webpack_require__.e(1657).then(function() { return function() { return __webpack_require__(11657); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.4.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",
	},
	13381: {
		fallback: function() { return __webpack_require__.e(6202).then(function() { return function() { return __webpack_require__(33821); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "13.4.9",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	61919: {
		fallback: function() { return __webpack_require__.e(1657).then(function() { return function() { return __webpack_require__(11657); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",
	},
	60262: {
		fallback: function() { return Promise.all([__webpack_require__.e(9905), __webpack_require__.e(8070), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791)]).then(function() { return function() { return __webpack_require__(58070); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	5194: {
		fallback: function() { return __webpack_require__.e(1657).then(function() { return function() { return __webpack_require__(11657); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",
	},
	69960: {
		fallback: function() { return __webpack_require__.e(4200).then(function() { return function() { return __webpack_require__(94200); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^23.16.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",
	},
	78179: {
		fallback: function() { return __webpack_require__.e(9642).then(function() { return function() { return __webpack_require__(9642); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "13.4.9",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	16187: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(49906); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/server",
	},
	66039: {
		fallback: function() { return Promise.all([__webpack_require__.e(9905), __webpack_require__.e(8070)]).then(function() { return function() { return __webpack_require__(58070); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.7.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [57910,39818,56549,23623,62019,36243,17253,44637,668,71383,668,68153,28766,56549,43526,39609,25609,6062,52041,15119,76643,68941,13299,25794,56497,13832,15173,97478,79974,72121,66025,99046,1509,37662,62105,13381,61919,6140,95791,60262,5194,69960,78179];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"262": [
		60262
	],
	"636": [
		56549,
		43526,
		39609,
		25609,
		6062,
		52041,
		15119,
		76643,
		68941,
		13299,
		25794,
		56497,
		13832,
		15173
	],
	"1778": [
		11778
	],
	"1919": [
		61919
	],
	"3381": [
		13381
	],
	"4290": [
		66039
	],
	"5527": [
		23623,
		62019,
		36243,
		17253,
		44637,
		668,
		71383
	],
	"5791": [
		95791
	],
	"5898": [
		72121
	],
	"6025": [
		66025
	],
	"6140": [
		6140
	],
	"6187": [
		16187
	],
	"6549": [
		56549
	],
	"6925": [
		6062,
		52041
	],
	"7478": [
		97478
	],
	"7910": [
		57910
	],
	"8179": [
		78179
	],
	"8365": [
		5194,
		69960
	],
	"8766": [
		28766
	],
	"8792": [
		668,
		68153,
		28766
	],
	"9046": [
		99046
	],
	"9506": [
		1509,
		37662,
		62105
	],
	"9818": [
		39818
	],
	"9974": [
		79974
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}